import { forwardRef, useEffect, useImperativeHandle, useRef } from "react";
import WAVAudioVisualizer from "./WAVAudioVisualizer";

interface WAVAudioProps {
  audioUrl: string;
  onIsPlayingChange?: (isPlaying: boolean) => void;
}

export interface WAVAudioRef {
  stop: () => void;
  toggle: () => void;
}

const WAVAudio = forwardRef<WAVAudioRef, WAVAudioProps>((props, ref) => {
  const visualizer = useRef<WAVAudioVisualizer>();

  useEffect(() => {
    const canvas = document.getElementById("visualizer") as HTMLCanvasElement;
    visualizer.current = new WAVAudioVisualizer(canvas, {
      ...props,
    });
  }, []);

  useImperativeHandle(ref, () => ({
    toggle: () => {
      visualizer.current?.toggle();
    },
    stop: () => {
      visualizer.current?.stop();
    },
  }));

  return <canvas id="visualizer" className="w-full h-full"></canvas>;
});

export default WAVAudio;
